import { render, staticRenderFns } from "./activities.vue?vue&type=template&id=3d1fd610&"
import script from "./activities.vue?vue&type=script&lang=js&"
export * from "./activities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports